import comp from "./LoadingDots";
export default comp;
